import { useEffect, useState } from "react"
import { CustomRadio } from "../../../../../../ui/molecules/radioButton"
import { Calendar } from "../../../../../../ui/molecules/calendar"
import TextArea from "../../../../../../ui/molecules/textArea"
import Button from "../../../../../../ui/molecules/button"
import { useAppDispatch, useAppSelector } from "../../../../../../lib/redux/hooks"
import { NotificationStatusUpdate, setNotificationStatusUpdateAdditionalNote, setNotificationStatusUpdateMotivation, setNotificationStatusUpdateNotificationValidation, setNotificationStatusUpdateValidationDate, setOnEdit } from "../../slice"

export function NotifyStatusEditRight() {
    const dispatch = useAppDispatch()
    const notificationStatusState = useAppSelector(state => state.notificationStatus)
    const [notifyCompliance, setNotifyCompliance] = useState<string | null>(null)

    useEffect(() => {
        if(notificationStatusState.notificationStatusUpdateRequest.notificationValidation !== null)
            setNotifyCompliance(notificationStatusState.notificationStatusUpdateRequest.notificationValidation ? 'SI' : 'NO')
    }, [])

    useEffect(() => {
        if(notificationStatusState.notificationStatusUpdateStatus === 'successfully') 
            dispatch(setOnEdit(false))
    }, [notificationStatusState.notificationStatusUpdateStatus])

    return (
        <div>
            <div className='text-left' style={{ padding: '24px 24px 12px 24px' }}>
                <span className='notify-title-bold' style={{ color: '#4D797F' }}>Stato </span>
                <span className='notify-title-bold' style={{ color: '#74A4A9' }}>/</span>
                <span className='notify-title-bold' style={{ color: '#314D51' }}> Validazione Notifica</span>
            </div>

            <div className='text-left' style={{ padding: '12px 24px 12px 24px', borderBottomWidth: 1 }}>
                <div className='notify-subtitle mb-3'>
                    Stato Conformità Notifica
                </div>
                <div className="mb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <span className='notify-text-content'>
                        Conformità Notifica
                    </span>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            options={[{ label: '', value: 'SI' }]}
                            selectedValue={notifyCompliance}
                            onChange={(value) => {
                                setNotifyCompliance(value)
                                dispatch(setNotificationStatusUpdateNotificationValidation(true))
                            }}
                            id={'notify_compliance_1'}
                            name={'notify_compliance_1'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>Sì</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            options={[{ label: '', value: 'NO' }]}
                            selectedValue={notifyCompliance}
                            onChange={(value) => {
                                setNotifyCompliance(value)
                                dispatch(setNotificationStatusUpdateNotificationValidation(false))
                            }}
                            id={'notify_compliance_2'}
                            name={'notify_compliance_2'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>No</span>
                        </div>
                    </div>
                </div>

                <div className='text-left'>
                    <div className='notify-subtitle'>
                        Data Validazione
                    </div>
                    <Calendar
                        selected={notificationStatusState.notificationStatusUpdateRequest.validationDate}
                        onChange={(date) => dispatch(setNotificationStatusUpdateValidationDate(date))}
                        onClear={(date) => dispatch(setNotificationStatusUpdateValidationDate(date))}
                    />
                </div>
            </div>

            <div className='text-left' style={{ padding: '12px 24px 12px 24px' }}>
                <div className="mb-5">
                    <div className='text-left notify-text-bold'>
                        Motivazione
                    </div>
                    <TextArea
                        value={notificationStatusState.notificationStatusUpdateRequest.motivation}
                        onChangeText={(text) => dispatch(setNotificationStatusUpdateMotivation(text))}
                    />
                </div>

                <div className="mb-5">
                    <div className='text-left notify-text-bold'>
                        Note
                    </div>
                    <TextArea
                        value={notificationStatusState.notificationStatusUpdateRequest.additionalNote}
                        onChangeText={(text) => dispatch(setNotificationStatusUpdateAdditionalNote(text))}
                    />
                </div>
            </div>

            <div className="pr-[24px]" style={{ display: 'flex', justifyContent: 'flex-end', gap: '18px' }}>
                <Button
                    variant="outline"
                    color="dimgrey"
                    size="md"
                    iconPosition="off"
                    label="Annulla"
                    onClick={() => dispatch(setOnEdit(false))}
                />
                <Button
                    variant="solid"
                    color="orange"
                    size="md"
                    iconPosition="off"
                    label="Salva"
                    onClick={() => dispatch(NotificationStatusUpdate({body: notificationStatusState.notificationStatusUpdateRequest, id: notificationStatusState.notificationStatusIdToUpdate}))}
                />
            </div>
        </div>
    )
}